module.exports = __webpack_public_path__ + "static/media/landing_page_video_1080p.08be15bb.mp4";